/* global filter_obj */

const $ = jQuery.noConflict();

/* ------------------------------ Script on ready ------------------------------ */
jQuery(document).ready(function($) {
    /************* Event FILTER - START *****************/
    $('.blog-author-section form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();

        $('.blog-author-section .lg-filter-selected-list').empty();

        const pager = $('.blog-author-section form.listing-filter-form #pager').val();
        const posts_per_page = $('.blog-author-section form.listing-filter-form input[name="posts_per_page"]').val();

        blog_author_filter_data(pager, posts_per_page);
    });
});

$(document).on('click', '.filter-load-more', function(e) {
    e.preventDefault();

    const pager = parseInt($(this).data('current-page')) + 1;
    $('.blog-author-section #pager').val(pager);
    $('.blog-author-section form.listing-filter-form').submit();
});

function blog_author_filter_data(pager, posts_per_page) {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url,
        data: {
            action: 'fetch_blog_author_post_list_data',
            security: filter_obj.nonce,
            pager: pager,
            posts_per_page: posts_per_page,

            // ✅ taxonomy data
            taxonomy: filter_obj.taxonomy,
            term_id: filter_obj.term_id,
        },
        beforeSend: function() {
            $('.blog-author-section .filter-loader').show();
            $('.blog-author-section .filter-load-more').hide();
        },
        success: function(response) {
            $('.blog-author-section .filter-loader').hide();

            const $grid = $('.blog-author-section .bas-list');
            let $newItems;

            if (pager === 1) {
                $grid.html(response.data);
                $newItems = $grid.find('.prl-item');
            } else {
                $newItems = $(response.data);
                $grid.append($newItems);
            }

            /* Prepare animation state */
            $newItems.css({
                opacity: 0,
                transform: 'translateY(30px)',
            });

            /* Animate new items */
            $newItems.each(function(i) {
                setTimeout(() => {
                    $(this).css({
                        opacity: 1,
                        transform: 'translateY(0)',
                        transition: 'all 0.5s ease',
                    });
                }, i * 120);
            });

            if (response.has_more) {
                $('.filter-load-more').data('current-page', response.pager).show();
            } else {
                $('.filter-load-more').parent().hide();
            }

            $('#pager').val(response.pager);
            $('#max_pages').val(response.total_pages);
        },
    });
}